import { apiFetch } from "../../services/api";

export async function consumeAgentStream(response, onProgress) {
  const decoder = new TextDecoder();
  if (!response.body) {
    throw new Error("Agent stream returned no body");
  }
  const reader = response.body.getReader();
  let buffer = "";
  let data = null;
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const lines = buffer.split("\n");
    buffer = lines.pop() || "";
    for (const line of lines) {
      if (!line.trim()) continue;
      let evt;
      try {
        evt = JSON.parse(line);
      } catch {
        continue;
      }
      if (evt.type === "progress" && Array.isArray(evt.visible_steps)) {
        onProgress(evt.visible_steps.filter(Boolean));
      } else if (evt.type === "complete") {
        data = evt.response;
      } else if (evt.type === "error") {
        throw new Error(evt.message || "Agent stream failed");
      }
    }
  }
  if (buffer.trim()) {
    try {
      const evt = JSON.parse(buffer);
      if (evt.type === "complete") data = evt.response;
    } catch {
      /* ignore partial tail */
    }
  }
  if (!data) {
    throw new Error("No response from agent stream");
  }
  return data;
}

export async function fetchAgentResponse(requestBody, onProgress, { debugWarn } = {}) {
  const postOpts = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/x-ndjson, application/json",
    },
    body: JSON.stringify(requestBody),
  };

  const applyVisibleSteps = (payload) => {
    if (Array.isArray(payload?.visible_steps) && payload.visible_steps.length) {
      onProgress(payload.visible_steps.filter(Boolean));
    }
    return payload;
  };

  try {
    const streamResponse = await apiFetch("/api/rag/v2/query/stream", postOpts);
    if (streamResponse.status === 404) {
      throw new Error("stream_unavailable");
    }
    if (!streamResponse.ok) {
      throw new Error("stream_http_error");
    }
    const contentType = streamResponse.headers.get("content-type") || "";
    if (
      contentType.includes("application/json") &&
      !contentType.includes("ndjson")
    ) {
      const json = await streamResponse.json();
      return applyVisibleSteps(json);
    }
    return await consumeAgentStream(streamResponse, onProgress);
  } catch (streamErr) {
    if (typeof debugWarn === "function") {
      debugWarn("Agent stream unavailable, using standard query:", streamErr);
    }
    const fallback = await apiFetch("/api/rag/v2/query", postOpts);
    if (!fallback.ok) {
      const errorData = await fallback.json().catch(() => ({}));
      throw new Error(errorData.detail || "Failed to process query");
    }
    const data = await fallback.json();
    return applyVisibleSteps(data);
  }
}
